import { GiftCardRequestDto } from './giftCardRequest.dto';

export class GiftCardTopupRequestDto extends GiftCardRequestDto {
  amount: number;
  merchantId: number;
  isInstorePayment?: boolean;
  entityId?: number;
  entityTypeId?: number;
  giftCardReasonId?: number;
  note?: string;
}
